import React, { useEffect, useState } from "react";
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import styled from "styled-components";
import BackButton from "../../../components/custom/BackButton";
import ActionIcon from "../../../components/custom/ActionIcon";
import { createdUpdatedInfo } from "../../../utils";
import { IssuedRow } from "./types";
import { Block, ErrorText, FieldLabel, FooterButtonsContainer, FooterContentContainer, HeaderContainer, Input, RequiredMark } from "./styles";

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

interface RevokeAssignmentModalProps {
    modal: boolean;
    setModal: (open: boolean) => void;
    row: IssuedRow | null;
    onRevoke: (quantity: number) => void;
}

export default function RevokeAssignmentModal({ modal, setModal, row, onRevoke }: RevokeAssignmentModalProps) {
    const [quantity, setQuantity] = useState("");
    const [error, setError] = useState("");

    const toggle = () => setModal(!modal);

    useEffect(() => {
        if (modal && row) {
            setQuantity(String(row.quantityAssigned));
            setError("");
        }
    }, [modal, row?.employeeId, row?.itemId]);

    if (!row) return null;

    const save = () => {
        const q = Number(quantity);
        if (quantity === "" || Number.isNaN(q) || q < 1) {
            setError("Enter at least one.");
            return;
        }
        if (q > row.quantityAssigned) {
            setError(`Only ${row.quantityAssigned} assigned.`);
            return;
        }
        onRevoke(q);
    };

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={"d-flex"}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={"pl-2"}>Revoke {row.itemName}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <div>{row.name}{row.email ? ` — ${row.email}` : ""}</div>
                <Block mt={4}>{row.quantityAssigned} assigned</Block>

                <Block mt={16}>
                    <FieldLabel>
                        Quantity to revoke <RequiredMark>*</RequiredMark>
                    </FieldLabel>
                    <Input
                        type="number"
                        min="1"
                        max={row.quantityAssigned}
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        mono
                        error={!!error}
                    />
                    {error && <ErrorText>{error}</ErrorText>}
                </Block>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <Label>{createdUpdatedInfo({})}</Label>
                    <FooterButtonsContainer>
                        <ActionIcon type={"save"} onClick={save} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}
